import { render, staticRenderFns } from "./CouponsCard.vue?vue&type=template&id=34b03cab&scoped=true&"
import script from "./CouponsCard.vue?vue&type=script&lang=js&"
export * from "./CouponsCard.vue?vue&type=script&lang=js&"
import style0 from "./CouponsCard.vue?vue&type=style&index=0&id=34b03cab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b03cab",
  null
  
)

export default component.exports